import React from "react";
import { FillPct, Loc } from "./types";
import KGrid from "./KGrid";

type Props = {
  rand: string;
  byCol: Map<string, Map<string, Loc[]>>;
  highlight: FillPct | null;
  resolveNivel: (l: Loc) => FillPct;
  depotId: string;
};

const RandRow: React.FC<Props> = ({
  rand,
  byCol,
  highlight,
  resolveNivel,
  depotId,
}) => {
  const kEntries: Array<[string, Map<string, Loc[]>]> = [];
  byCol.forEach((polite, kKey) => {
    kEntries.push([kKey, polite]);
  });

  kEntries.sort(([a], [b]) => a.localeCompare(b, undefined, { numeric: true }));

  return (
    <div
      className="wm-row"
      id={`wm-row-${depotId}-${rand}`}
      data-depot={depotId}
      data-rand={rand}>
      <div className="wm-row-label">{rand}</div>
      <div className="wm-col-scroller">
        {kEntries.map(([kKey, polite]) => (
          <div key={kKey} className="wm-col">
            <div className="wm-col-header">{kKey}</div>
            <KGrid
              polite={polite}
              highlight={highlight}
              resolveNivel={resolveNivel}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default React.memo(RandRow);
